// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "umi") return "umi.css";
	// return url for filenames based on template
	return "" + chunkId + ".chunk.css";
};